<div class="page_container" *ngIf="(segments$ | async)!.length > 0">
    <div class="listing_table_container">
        <table class="listing_table">
            <thead>
                <tr class="head_table">
                    <th>{{"segment.segment_name"| translate}}<br>{{"segment.field_type"| translate}}</th>
                    <th>{{"segment.field_type_values"|translate}}</th>
                    <th>{{"common.description"|translate}}</th>
                    <th>{{"segment.companies_using_it"| translate}}</th>
                    <th>{{"common.status"| translate}}</th>
                    <th>{{"common.actions"| translate}}</th>
                </tr>
            </thead>
            <tbody class="scrollable-body">
                <ng-container *ngFor="let segment of (segments$ | async)">
                    <tr class="body_table">
                        <td class="td_block first_td cursor" (click)="opensSegments(segment)">
                            <span class="bold_span">
                                {{ segment.name }}
                            </span><br>
                            <span class="light_span">
                                {{segment.value_type === 'boolean' ? ('segment.yes_no' | translate) : segment.value_type === 'multi-select' ? ('common.multi_select' | translate) : segment.value_type === 'single-select' ? ('common.single_select' | translate) : segment.value_type === 'text' ? ('common.label' | translate) : ''}}
                            </span>
                        </td>
                        <td class="td_block cursor" (click)="opensSegments(segment)">
                            {{ isArray(segment.value_options) ? segment.value_options.join('/ ') : segment.value_options }}
                            <span *ngIf="segment.value_type === 'boolean'" >{{'segment.yes_no' | translate}}</span>
                        </td>
                        <td class="td_actions cursor" (click)="opensSegments(segment)">
                            {{segment.description}}
                        </td>
                        <td class="td_actions">
                                {{segment.nbr_locations}}
                        </td>
                        <td class="sub_categories_cell">
                            <span *ngIf="segment.status" [class.active]="segment.status === 'published'" class="status">{{getStatusTranslation(segment.status)}}</span>
                        </td>
                        <td>
                            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="opensSegments(segment)">
                                <mat-icon>edit</mat-icon>
                                <span>{{"common.edit"| translate}}</span>
                            </button>
                            <button mat-menu-item (click)="delete(segment.id)">
                                <mat-icon>delete</mat-icon>
                                <span>{{"common.del"|translate}}</span>

                            </button>
                            </mat-menu>
                        </td>
                    </tr>
                    <!-- <tr *ngIf="expandedIndex === segment.id">
                        <td colspan="6" class="td_variants">
                            <div class="variants_scroll">
                                <table class="variant_table">
                                    <thead>
                                        <tr *ngIf="expandedIndex === segment.id" class="head_table list_companies">
                                            <th>Company name</th>
                                            <th>Europe</th>
                                            <th>Afrique</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tr *ngFor="let companies of segment.companies" class="body_table list_companies">
                                        <td class="first_td_variants td_block first_td">
                                            <span>
                                                {{ companies.name }}
                                            </span>
                                        </td>
                                        <td class="first_td_variants td_block first_td">
                                            <span>
                                                {{ companies.europe }}
                                            </span>
                                        </td>
                                        <td class="first_td_variants td_block first_td">
                                            <span>
                                                {{ companies.afrique }}
                                            </span>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </td>
                    </tr> -->
                </ng-container>
            </tbody>
        </table>
    </div>
    <app-pagination [pagination]="pagination$ | async" (toPageEvent)="toPage($event)"></app-pagination>
</div>
<div *ngIf="(segments$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
    <ng-container *ngIf="filter?.filters!.length === 0 && !key">
      <img class="no_intense" src="../../../../../assets/icones/no-segments.svg" alt="">
      <h3>{{"segment.no_segments" | translate}}</h3>
    </ng-container>
    <ng-container *ngIf="filter?.filters!.length > 0 || key">
      <img class="no_intense" src="../../../../../assets/icones/no-result-search.svg" alt="">
      <h3>{{"segment.no_data_search" | translate }}</h3>
    </ng-container>
    <button *ngIf="filter?.filters!.length === 0 && !key" class="save_btn_pop_up blue_btn" (click)="addSegments()">
        <span>{{"common.add" | translate | uppercase}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
  </div>
